import { VSImageShapeOrTextElementModel } from 'js/types';

export const getEditorSVGDimensions = (element: VSImageShapeOrTextElementModel) => ({
  scaleX: 1,
  scaleY: 1,
  width: element.width * element.scaleX,
  height: element.height * element.scaleY
});
